import React, { useState, useEffect } from "react";
import axios from "axios";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ExportBLFirstDT = (props) => {
  // const [baseUrl, setBaseUrl] = useState('http://127.0.0.1:8000/api/');
  const [baseUrl, setBaseUrl] = useState("http://mol.evolve-demo.com/api/");
  const [pageComponent, setPageComponent] = useState("exportbl");
  const [blNumList, setBlNumList] = useState(undefined);

  try {
    useEffect(() => {
      fetch(`${baseUrl}${pageComponent}/getBLNO`)
        .then((response) => response.json())
        .then((data) => {
          setBlNumList(data.blno);
        });
    }, []);
  } catch (error) {
    if (error.response && error.response.status === 429) {
    } else {
      console.error(error);
    }
  }
  return (
    <Container>
      <ToastContainer autoClose={2000} />
      <Row>
        <Col>
          <Form className="mt-4 bottom-border pb-3">
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="formGroupEmail">
                  <Form.Label>Master BL NO</Form.Label>
                  <Form.Select
                    name="BLNO"
                    aria-label=""
                    onChange={props.onpageValueHadleFunction}
                    value={
                      props.pageValuesData.BLNO ? props.pageValuesData.BLNO : ""
                    }
                  >
                    <option value=""></option>
                    <>
                      {Array.isArray(blNumList)
                        ? blNumList.map((bLItem, id) => (
                            <option value={bLItem.id} key={id}>
                              {bLItem.BLNo}
                            </option>
                          ))
                        : ""}
                    </>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="formGroupEmail">
                  <Form.Label>House BL NO</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="House BL NO"
                    autoComplete="off"
                    name="Hbl"
                    onChange={props.onpageValueHadleFunction}
                    value={
                      props.pageValuesData.Hbl !== ""
                        ? props.pageValuesData.Hbl
                        : ""
                    }
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="formGroupEmail">
                  <Form.Label>Date</Form.Label>
                  <Form.Control
                    type="date"
                    placeholder=""
                    autoComplete="off"
                    name="Date"
                    onChange={props.onpageValueHadleFunction}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="formGroupEmail">
                  <Form.Label className="">Vessel</Form.Label>
                  <br />
                  <Form.Label className="printted-label">
                    {props.pageValuesData.VesCode !== ""
                      ? props.pageValuesData.VesCode
                      : ""}
                  </Form.Label>
                  <Form.Label className="printted-label ms-3">
                    {props.pageValuesData.VesDesc !== ""
                      ? props.pageValuesData.VesDesc
                      : ""}
                  </Form.Label>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="formGroupEmail">
                  <Form.Label className="">Voyage</Form.Label>
                  <br />
                  <Form.Label className="printted-label">
                    {props.pageValuesData.voyCode !== ""
                      ? props.pageValuesData.voyCode
                      : ""}
                  </Form.Label>
                  <Form.Label className="ms-3 printted-label">
                    {props.pageValuesData.voyDesc !== ""
                      ? props.pageValuesData.voyDesc
                      : ""}
                  </Form.Label>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="formGroupEmail">
                  <Form.Label className="">Poprt of Loading</Form.Label>
                  <br />
                  <Form.Label className="printted-label">
                    {props.pageValuesData.PortLoadCode !== ""
                      ? props.pageValuesData.PortLoadCode
                      : ""}{" "}
                  </Form.Label>
                  <Form.Label className="ms-3 printted-label">
                    {props.pageValuesData.PortLoadDesc !== ""
                      ? props.pageValuesData.PortLoadDesc
                      : ""}
                  </Form.Label>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="formGroupEmail">
                  <Form.Label className="">Port of disch</Form.Label>
                  <br />
                  <Form.Label className="printted-label">
                    {props.pageValuesData.PortDischCode !== ""
                      ? props.pageValuesData.PortDischCode
                      : ""}{" "}
                  </Form.Label>
                  <Form.Label className="ms-3 printted-label">
                    {props.pageValuesData.PortDischDesc !== ""
                      ? props.pageValuesData.PortDischDesc
                      : ""}
                  </Form.Label>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="formGroupEmail">
                  <Form.Label>Place OF Delivery</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder=""
                    name="PlaceOfDelivery"
                    value={
                      props.pageValuesData.PlaceOfDelivery
                        ? props.pageValuesData.PlaceOfDelivery
                        : ""
                    }
                    onChange={props.onpageValueHadleFunction}
                    autoComplete="off"
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="formGroupEmail">
                  <Form.Label>Place OF Receipt</Form.Label>
                  <Form.Control
                    type="text"
                    name="PlaceOfReceipt"
                    autoComplete="off"
                    value={
                      props.pageValuesData.PlaceOfReceipt
                        ? props.pageValuesData.PlaceOfReceipt
                        : ""
                    }
                    onChange={props.onpageValueHadleFunction}
                    placeholder=""
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="formGroupEmail">
                  <Form.Label>Pre-carriage by</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder=""
                    name="PreCarrageBy"
                    value={
                      props.pageValuesData.PreCarrageBy
                        ? props.pageValuesData.PreCarrageBy
                        : ""
                    }
                    onChange={props.onpageValueHadleFunction}
                    autoComplete="off"
                  />
                </Form.Group>
              </Col>

              <Col>
                <Form.Group className="mb-3" controlId="MasterBL">
                  <Form.Label>Final destination</Form.Label>
                  <Form.Control
                    type="text"
                    autoComplete=""
                    name="FinalDestination"
                    value={
                      props.pageValuesData.FinalDestination
                        ? props.pageValuesData.FinalDestination
                        : ""
                    }
                    onChange={props.onpageValueHadleFunction}
                    placeholder=""
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="formGroupEmail">
                  <Form.Label>Gross Weight</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder=""
                    name="GrossWeight"
                    value={
                      props.pageValuesData.GrossWeight
                        ? props.pageValuesData.GrossWeight
                        : ""
                    }
                    onChange={props.onpageValueHadleFunction}
                    autoComplete="off"
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="formGroupEmail">
                  <Form.Label>No of Conta or Pkgs</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder=""
                    name="NoOfConPack"
                    value={
                      props.pageValuesData.NoOfConPack
                        ? props.pageValuesData.NoOfConPack
                        : ""
                    }
                    onChange={props.onpageValueHadleFunction}
                    autoComplete="off"
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="formGroupEmail">
                  <Form.Label>Measurment</Form.Label>
                  <Form.Control
                    type="text"
                    autoComplete=""
                    name="Measurments"
                    value={
                      props.pageValuesData.Measurments
                        ? props.pageValuesData.Measurments
                        : ""
                    }
                    onChange={props.onpageValueHadleFunction}
                    placeholder=""
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="formGroupEmail">
                  <Form.Label>
                    Total No of Conta or other Pkgs or unites receive bt the
                    carrier(In Words)
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder=""
                    autoComplete="off"
                    name="TotNoOfConPackInWord"
                    value={
                      props.pageValuesData.TotNoOfConPackInWord
                        ? props.pageValuesData.TotNoOfConPackInWord
                        : ""
                    }
                    onChange={props.onpageValueHadleFunction}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="MasterBL">
                  <Form.Label>Shipper</Form.Label>
                  <Form.Control
                    as="textarea"
                    name="Shipper"
                    value={
                      props.pageValuesData.Shipper
                        ? props.pageValuesData.Shipper
                        : ""
                    }
                    onChange={props.onpageValueHadleFunction}
                    placeholder=""
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="formGroupEmail">
                  <Form.Label>Consignee</Form.Label>
                  <Form.Control
                    as="textarea"
                    name="Consignee"
                    value={
                      props.pageValuesData.Consignee
                        ? props.pageValuesData.Consignee
                        : ""
                    }
                    onChange={props.onpageValueHadleFunction}
                    placeholder=""
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="formGroupEmail">
                  <Form.Label>Notify Party</Form.Label>
                  <Form.Control
                    as="textarea"
                    name="NotifyParty"
                    value={
                      props.pageValuesData.NotifyParty
                        ? props.pageValuesData.NotifyParty
                        : ""
                    }
                    onChange={props.onpageValueHadleFunction}
                    placeholder=""
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="formGroupEmail">
                  <Form.Label> For delivery of goods please</Form.Label>
                  <Form.Control
                    as="textarea"
                    name="DeliveryOfGoods"
                    value={
                      props.pageValuesData.DeliveryOfGoods
                        ? props.pageValuesData.DeliveryOfGoods
                        : ""
                    }
                    onChange={props.onpageValueHadleFunction}
                    placeholder="For delovery of goods please here"
                  />
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default ExportBLFirstDT;
